import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Facturacion from "../views/Facturacion.vue";
import HistorialOk from "../views/HistorialOk.vue";
import HistorialErr from "../views/HistorialError.vue";
import Profile from "../views/components/ProfileCard.vue";
import Emisores from "../views/components/Emisores.vue";
import Usuarios from "../views/components/Usuarios.vue";
import layout from "../views/Layout.vue";
import Signin from "../views/Signin.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/signin",
    component: Signin,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/procesarPagos",
    name: "procesarPagos",
    component: Facturacion,
  },
  
  {
    path: "/layout",
    name: "Layout",
    component: layout,
  },
  {
    path: "/historialProcesadas",
    name: "Historial Procesadas",
    component: HistorialOk,
  },
  {
    path: "/historialError",
    name: "Historial con Errores",
    component: HistorialErr,
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: Profile,
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    component: Usuarios,
  },
  {
    path: "/emisores",
    name: "Emisores",
    component: Emisores,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
